import React, {useState, useContext, useEffect,useRef } from "react";
import UserMenu from "./UserMenu";
import { Link } from "react-router-dom";
import "./title-bar.css";
import dishIcon from "../../assets/dish_icon.png";
import logo from "../../assets/logo.jpg";
import colabKitchenTitle from '../../assets/colabKitchenTitle.jpg';
import { DishContext } from "../../providers/DishProvider";
//import {useUserAuth} from '../Context/AuthUserContext'
import UpdatedLoginMethod from "../LogIn_PopUp/UpdatedLoginMethod";
import { auth } from "../../config/firebase";
function TitleBar() {
  const value = useContext(DishContext);
  const [cart] = value.cart;
  const [refresh, setRefresh] = value.refresh;  // keeping this since it's used
  const prevLengthRef = useRef(cart.length);
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    if (cart.length > prevLengthRef.current) {
      setAnimate(true);
      const timeout = setTimeout(() => {
        setAnimate(false);
      }, 300);
      return () => clearTimeout(timeout);
    }
    prevLengthRef.current = cart.length;
  }, [cart.length]);
  return (
    <div className="title-bar">
      <Link to="/">
        <img className="logo" src={logo} alt="logo" />
      </Link>
      
      <div className="title-container">
        <img src={colabKitchenTitle} className="colab-kitchen-title" alt='colabkitchen' />
      </div>
      
      <div className="right-container">
        <div className="dish_icon_container" style={{ position: 'relative' }}> {/* Added position relative */}
          <Link style={{ textDecoration: "none" }} to="/add-to-cart">
            {cart.length > 0 && (
              <>
                <div style={{
  position: 'absolute',
  zIndex: 1,
  left: '-28px',  // Adjusted to accommodate larger size
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'white',
  borderRadius: '50%',
  padding: '3px',
  width: '30px',    
  height: '30px',  
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
}} className={animate ? 'animate-bounce' : ''}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    style={{
      width: '100%',    
      height: '100%'    
    }}
    fill="#f09133"
  >
    <path d="m480-560-56-56 63-64H320v-80h167l-64-64 57-56 160 160-160 160ZM280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM40-800v-80h131l170 360h280l156-280h91L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68.5-39t-1.5-79l54-98-144-304H40Z"/>
  </svg>
</div>
    <span className="cart-icon">{cart.length}</span>
     </>
    )}
            <img className="dish_img" src={dishIcon} alt="dish_icon" />
          </Link>
        </div>
        {!auth.currentUser ? (
          <div>
            <UpdatedLoginMethod/>
          </div>
        ) : <UserMenu />}
      </div>
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(-50%) translateX(0); }
          50% { transform: translateY(-50%) translateX(-3px); }
        }
        .animate-bounce {
          animation: bounce 0.3s ease-in-out;
        }
      `}</style>
    </div>
  );
}
export default TitleBar;













// import React, { useContext } from "react";
// import UserMenu from "./UserMenu";
// import { Link } from "react-router-dom";

// import "./title-bar.css";
// import dishIcon from "../../assets/dish_icon.png";
// import logo from "../../assets/logo.jpg";
// import colabKitchenTitle from '../../assets/colabKitchenTitle.jpg';
// import { DishContext } from "../../providers/DishProvider";
// import {useUserAuth} from '../Context/AuthUserContext'
// import UpdatedLoginMethod from "../LogIn_PopUp/UpdatedLoginMethod";
// import { auth } from "../../config/firebase";

// function TitleBar() {
//   const value = useContext(DishContext);
//   const [cart] = value.cart;
//   const [refresh, setRefresh] = value.refresh;
//   const {Fbuser} = useUserAuth();
  
//   return (
//     <div className="title-bar">
//       <Link to="/">
//         <img className="logo" src={logo} alt="logo" />
//       </Link>

//       <div className="title-container">
//         <img src={colabKitchenTitle} className="colab-kitchen-title" alt='colabkitchen' />
//       </div>
      
//       <div className="right-container">

//         <div className="dish_icon_container">
//           <Link style={{ textDecoration: "none" }} to="/add-to-cart">
//             {cart.length > 0 ? (
//               <span className="cart-icon">{cart.length}</span>
//             ) : null}
//             <img className="dish_img" src={dishIcon} alt="dish_icon" />
//           </Link>
//         </div>
       
//        {!auth.currentUser ? (
//         <div>
//             <UpdatedLoginMethod/>
//         </div>
//        ):<UserMenu />}
        
       
//       </div>
      
//     </div>
//   );
// }

// export default TitleBar;